import { UserAuthStore } from "@state/shared";
import { action, computed, observable } from "mobx";

export interface IErrorMessage {
	username?: string;
	errData: { message: string; stack: string | undefined };
	timestamp: string;
}

export class DiagnosticsProvider {
	authStore: UserAuthStore;
	@observable errorMessages: IErrorMessage | null;

	constructor(userAuthStore: UserAuthStore) {
		this.authStore = userAuthStore;
	}

	@action.bound
	recordErrorMsg(data: IErrorMessage) {
		this.errorMessages = {
			...data,
			username: this.authStore.user?.username,
		};
	}

	@computed
	get diagnosticsData() {
		return JSON.stringify(this.errorMessages);
	}

	@action.bound
	onDispose() {
		this.errorMessages = null;
	}
}
